import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { NavMenuComponent } from './nav-menu/nav-menu.component';
import { MsalService } from '@azure/msal-angular';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, NavMenuComponent],
  templateUrl: './app.component.html',
  // styleUrl: './app.component.scss'
})

export class AppComponent {
  private subscription = new Subscription();
  title = 'XReg';

  constructor(private authService: MsalService) {}

  ngOnInit() {
    this.subscription.add(
      this.authService.handleRedirectObservable().subscribe({
        next: (result) => {
          if (result) {
            this.authService.instance.setActiveAccount(result.account);
          }
        },
        error: (error) => console.log(error),
      })
    );
  }

  ngonDestroy(): void {
    this.subscription.unsubscribe();
  }
}
